export default "__VITE_ASSET__f21079d1__"